// Sunrise and sunset for a place and a local date (W-01's day line), as PFCore SunTimes: the NOAA
// approximation, within a minute or two. Null in polar day or night.
export function sunTimes(date: string, lat: number, lng: number): { rise: number; set: number } | null {
  const [y, m, d] = date.split('-').map(Number);
  if (!y || !m || !d) return null;
  const noon = Date.UTC(y, m - 1, d, 12);
  const dayOfYear = Math.round((noon - Date.UTC(y, 0, 1, 12)) / 86_400_000) + 1;
  const rad = Math.PI / 180;
  const g = ((2 * Math.PI) / 365) * (dayOfYear - 1);
  const eqTime =
    229.18 *
    (0.000075 +
      0.001868 * Math.cos(g) -
      0.032077 * Math.sin(g) -
      0.014615 * Math.cos(2 * g) -
      0.040849 * Math.sin(2 * g));
  const decl =
    0.006918 -
    0.399912 * Math.cos(g) +
    0.070257 * Math.sin(g) -
    0.006758 * Math.cos(2 * g) +
    0.000907 * Math.sin(2 * g) -
    0.002697 * Math.cos(3 * g) +
    0.00148 * Math.sin(3 * g);
  const cosHA =
    Math.cos(90.833 * rad) / (Math.cos(lat * rad) * Math.cos(decl)) - Math.tan(lat * rad) * Math.tan(decl);
  if (cosHA < -1 || cosHA > 1) return null;
  const ha = Math.acos(cosHA) / rad;
  const midnight = noon - 12 * 3_600_000;
  return {
    rise: midnight + (720 - 4 * (lng + ha) - eqTime) * 60_000,
    set: midnight + (720 - 4 * (lng - ha) - eqTime) * 60_000,
  };
}

/** "06:21" in a zone. */
export const wallTime = (ms: number, tz?: string | null) =>
  new Intl.DateTimeFormat('en-GB', {
    timeZone: tz ?? undefined,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(ms);
